<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Offerte/Offerte_top.jpg">
<div class="content">
    <h1>Offerte</h1>
</div>
</div>
<!-- <br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Riserva naturale Valli Cupe</a></p>
</div>
<br> -->
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            In ogni stagione dell’anno l’Agenzia riserva ai propri clienti pacchetti e proposte turistiche con sconti speciali: 
            dalle offerte last minute degli operatori turistici alle migliori soluzioni di viaggio all inclusive a prezzi vantaggiosi.
            <br>
            <br>
            Basterà guardare con attenzione questa sezione e individuare la vacanza che risponde ai propri bisogni e desideri, 
            inteso che il team dell’Agenzia è a disposizione dei clienti per trovare anche altre  soluzioni personalizzate.
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>